import React from 'react';
import {
  IconButton,
  Popover,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Box
} from '@mui/material';
import AppsIcon from '@mui/icons-material/Apps';
import { useIntl } from 'react-intl';

import { usePopover } from 'src/hooks/usePopover';
import Tooltip from 'src/components/Tooltip';
import useUser from 'src/hooks/useUser';

const AppLauncher = () => {
  const { user } = useUser();
  const popover = usePopover();
  const { formatMessage } = useIntl();

  return (
    <>
      <Tooltip
        title={formatMessage({
          defaultMessage: 'アプリケーション選択',
          id: 'TopBar.AppLauncher.Tooltip.Title'
        })}
      >
        <IconButton
          color="textPrimary"
          ref={popover.anchorRef}
          onClick={popover.handleToggle}
        >
          <AppsIcon />
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <ImageList cols={3} rowHeight={96} gap={6} sx={{ p: 2 }}>
          {user.available_apps.map((app) => (
            <ImageListItem key={app.link} sx={{ alignItems: 'center' }}>
              <IconButton component="a" href={app.link} target="_blank">
                <Box component="img" src={app.image} sx={{ height: 30 }} />
              </IconButton>
              <ImageListItemBar
                title={user.language === 'ja' ? app.name : app.name_en}
                position="below"
                sx={{
                  '& .MuiImageListItemBar-title': {
                    fontSize: 14
                  }
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Popover>
    </>
  );
};

export default AppLauncher;
